<style>
    footer {
        display: flex;
        justify-content: center;
        width: 100%;
        height: 80px;
    }
    img {
        height: 40px; 
        width: auto; 
        margin: 0 20px 20px;
    }

    @media (max-width: 640px) {
        img {
            height: 30px;
            margin-bottom: 15px;
        }
    }
</style>

<footer>
    <a href="https://warnermusic.co.th/en/"><img src="/assets/warner.png" alt=""></a>
    <a href="https://warnermusic.co.th/en/wayfer-records/"><img src="/assets/wayfer.png" alt=""></a>
</footer>